export const resources_EN = {
  success: "success",
  successTitle: "Success",
  error: "error",
  errorTitle: "Error",
};

export const Path = {
  admin: "/admin",
};

export const productColumns = [
  { key: "id", label: "ID", sortable: true, width: "60px" },
  { key: "prod_name", label: "Name", sortable: true },
  { key: "prod_price", label: "Price", sortable: true },
  { key: "cat_title", label: "Category", sortable: true },
  { key: "prod_quantity", label: "Quantity", sortable: true },
];

export const categoryColumns = [
  { key: "cat_title", label: "Category Name", sortable: true },
];
